<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <discount-info :isUp="isUp"></discount-info>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import discountInfo from './Temp/DiscountInfo.vue'
export default {
  components: {
    'discount-info': discountInfo
  },
  data () {
    return {
      isUp: true
    }
  },
  methods: {

  },
  created () {
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// DiscountInfo.vue?7935e4d0